import React from 'react'

import { Typography } from 'antd'

import { reqSl5 } from '../../api'
const { Paragraph } = Typography

class SL5 extends React.Component {
    state = {
        sl5: ''
    }

    async componentDidMount() {
        const res = await reqSl5()
        let sl5 = ''
        if (res.code === 0) {
            sl5 = res.data[0].content
        }

        this.setState({sl5: sl5})
    }

    render() {
        const { sl5 } = this.state

        return (
            <Paragraph className="aboutus-text">
                <div dangerouslySetInnerHTML = {{ __html: sl5 }}></div>
            </Paragraph>
        )
    }
}


export default SL5